import { Box, Button, Page, ProgressStepper, Text } from '@zillow/constellation-10';
import { Link } from 'react-router-dom';
import { manifest } from '../../app/routes';

export interface GuestPayProgressHeaderProps {
  activeStepIndex: number;
}

const mapAppearance = (step: StepLabel, stepIndex: number, activeStepIndex: number) => {
  let tone;
  if (stepIndex === activeStepIndex) {
    tone = 'incomplete';
  }
  if (stepIndex < activeStepIndex) {
    tone = 'complete';
  }
  return {
    ...step,
    tone,
  };
};

interface StepLabel {
  label: string;
  appearance?: string;
}

const AVAILABLE_STEPS: Array<StepLabel> = [
  { label: 'Select invoice' },
  { label: 'Payment details' },
  { label: 'Submit payment' },
];

const mapLabelIndex = (activeStepIndex: number) => {
  if (activeStepIndex === 0) {
    return 'Select invoice';
  } else if (activeStepIndex === 1) {
    return 'Payment details';
  } else if (activeStepIndex === 2) {
    return 'Submit payment';
  }
};

export const GuestPayProgressHeader = ({ activeStepIndex }: GuestPayProgressHeaderProps) => {
  const steps = AVAILABLE_STEPS.map((step, i) => mapAppearance(step, i, activeStepIndex));
  return (
    <Box css={{ width: '100%', background: 'white' }}>
      <Page.Root css={{ padding: '0 !important', background: 'white' }}>
        <Page.Content css={{ marginBlock: '400 !important', maxWidth: '1232px', paddingInline: '600 !important' }}>
          <Box css={{ display: 'flex', alignItems: 'center' }}>
            <Box css={{ width: '15%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
              <Text textStyle="heading-xs">{mapLabelIndex(activeStepIndex)}</Text>
              <Text textStyle="body-sm">{`Step ${activeStepIndex + 1} of 3`}</Text>
            </Box>
            <Box css={{ flexGrow: 2 }}>
              <ProgressStepper activeStepIndex={activeStepIndex} steps={steps} />
            </Box>
            <Box
              css={{
                width: '15%',
                textAlign: 'right',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
              }}
            >
              <Box>
                <Button tone="brand" emphasis="outlined" asChild>
                  <Link to={manifest.guestPayPage}>Exit</Link>
                </Button>
              </Box>
            </Box>
          </Box>
        </Page.Content>
      </Page.Root>
    </Box>
  );
};
